module.exports={
  "name": "linq-js",
  "version": "2.2.0",
  "description": "use linq and lamdba in javascript",
  "main": "dist/linq.full.min.js",
  "scripts": {
    "test:performance": "node test/performance/test.js",
    "test": "node test/test.js && node test/full/test.js",
    "test:compile": "npm run compile && node test/test-compile.js && node test/full/test-compile.js",
    "test:babel": "npx babel-node test/test-babel.js && npx babel-node test/full/test-babel.js",
    "test:unit": "gulp unitSlim && gulp unitFull",
    "test:slim": "node test/test.js",
    "test:slim:compile": "npm run compile:slim && node test/test-compile.js",
    "test:slim:babel": "npx babel-node test/test-babel.js",
    "test:slim:unit": "gulp unitSlim",
    "test:full": "node test/full/test.js",
    "test:full:compile": "npm run compile:full && node test/full/test-compile.js",
    "test:full:babel": "npx babel-node test/full/test-babel.js",
    "test:full:unit": "gulp unitFull",
    "codecov": "nyc --reporter=lcov mocha ./test/mocha.js --timeout 10000 && codecov",
    "compile:slim": "gulp slim",
    "compile:full": "gulp full",
    "compile": "gulp",
    "prepublish": "npm run compile && npm run codecov"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/wm123450405/linqjs.git"
  },
  "devDependencies": {
    "@babel/cli": "^7.13.0",
    "@babel/core": "^7.13.0",
    "@babel/node": "^7.13.0",
    "@babel/plugin-transform-runtime": "^7.13.0",
    "@babel/preset-env": "^7.13.0",
    "assertrue": "^1.0.4",
    "babelify": "^10.0.0",
    "browserify": "^17.0.0",
    "codecov": "^3.8.2",
    "core-js": "^3.15.0",
    "exorcist": "^2.0.0",
    "extend": "^3.0.1",
    "gulp": "^4.0.2",
    "gulp-jshint": "^2.1.0",
    "gulp-rename": "^2.0.0",
    "gulp-sourcemaps": "^3.0.0",
    "gulp-terser": "^2.0.1",
    "gulp-uglify": "^3.0.0",
    "jshint": "^2.13.0",
    "mocha": "^9.0.1",
    "nyc": "^15.1.0",
    "terser": "^5.7.0",
    "uglify-js": "^3.13.0",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^2.0.0"
  },
  "engines": {
    "node": ">=6.0.0"
  },
  "keywords": [
    "linqjs",
    "linq",
    "js",
    "array",
    "lamdba",
    "enumerable",
    "queryable"
  ],
  "author": "wm123450405",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/wm123450405/linqjs/issues"
  },
  "homepage": "https://github.com/wm123450405/linqjs#readme",
  "types": "src/linq.d.ts"
}
